import createIcon from '../../createIcon';

/**
 * @component @name BookOnline
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMUg3QzUuOSAxIDUgMS45IDUgM1YyMUM1IDIyLjEgNS45IDIzIDcgMjNIMTdDMTguMSAyMyAxOSAyMi4xIDE5IDIxVjNDMTkgMS45IDE4LjEgMSAxNyAxWk03IDE4VjZIMTdWMThIN1pNMTYgMTFWOS4xNEMxNiA4LjUxIDE1LjU1IDggMTUgOEg5QzguNDUgOCA4IDguNTEgOCA5LjE0VjExLjFDOC41NSAxMS4xIDkgMTEuNTUgOSAxMi4xQzkgMTIuNjUgOC41NSAxMy4xIDggMTMuMVYxNC44NkM4IDE1LjQ5IDguNDUgMTYgOSAxNkgxNUMxNS41NSAxNiAxNiAxNS40OSAxNiAxNC44NlYxM0MxNS40NSAxMyAxNSAxMi41NSAxNSAxMkMxNSAxMS40NSAxNS40NSAxMSAxNiAxMVpNMTIuNSAxNC41SDExLjVWMTMuNUgxMi41VjE0LjVaTTEyLjUgMTIuNUgxMS41VjExLjVIMTIuNVYxMi41Wk0xMi41IDEwLjVIMTEuNVY5LjVIMTIuNVYxMC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BookOnline = createIcon('BookOnline', [
  [
    'path',
    {
      d: 'M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM7 18V6H17V18H7ZM16 11V9.14C16 8.51 15.55 8 15 8H9C8.45 8 8 8.51 8 9.14V11.1C8.55 11.1 9 11.55 9 12.1C9 12.65 8.55 13.1 8 13.1V14.86C8 15.49 8.45 16 9 16H15C15.55 16 16 15.49 16 14.86V13C15.45 13 15 12.55 15 12C15 11.45 15.45 11 16 11ZM12.5 14.5H11.5V13.5H12.5V14.5ZM12.5 12.5H11.5V11.5H12.5V12.5ZM12.5 10.5H11.5V9.5H12.5V10.5Z',
      key: '1oaiub',
    },
  ],
]);

export default BookOnline;
